import { render, staticRenderFns } from "./HospitalSet.vue?vue&type=template&id=28eedf76&scoped=true&"
import script from "./HospitalSet.vue?vue&type=script&lang=js&"
export * from "./HospitalSet.vue?vue&type=script&lang=js&"
import style1 from "./HospitalSet.vue?vue&type=style&index=1&id=28eedf76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eedf76",
  null
  
)

export default component.exports